import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
} from '@mui/material';
import { DialogTitleWithClose } from '../../common';

const formatDateInput = date => {
  if (!date) return '';
  const d = new Date(date);
  const year = d.getFullYear();
  const month = `${d.getMonth() + 1}`.padStart(2, '0');
  const day = `${d.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const DateRangeDialog = ({ open, onApply, onClose, initialRange }) => {
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  useEffect(() => {
    if (open) {
      setStart(formatDateInput(initialRange?.startDate) || '');
      setEnd(formatDateInput(initialRange?.endDate) || '');
    }
  }, [open, initialRange]);

  const canApply = Boolean(start && end && new Date(start) <= new Date(end));

  const handleApply = () => {
    if (!canApply) return;
    // Convert to ISO strings at local midnight boundaries
    const startDate = new Date(start);
    const endDate = new Date(end);
    // Ensure end has end-of-day time by adding 23:59:59.999
    const endDateWithTime = new Date(endDate);
    endDateWithTime.setHours(23, 59, 59, 999);
    onApply({
      startDate: startDate.toISOString(),
      endDate: endDateWithTime.toISOString(),
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitleWithClose
        title="Select custom date range"
        onClose={onClose}
      />
      <DialogContent>
        <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
          <TextField
            label="Start date"
            type="date"
            value={start}
            onChange={e => setStart(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
          <TextField
            label="End date"
            type="date"
            value={end}
            onChange={e => setEnd(e.target.value)}
            InputLabelProps={{ shrink: true }}
            fullWidth
            inputProps={{ min: start || undefined }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleApply} variant="contained" disabled={!canApply}>
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DateRangeDialog;
